import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { InsertDocenteRequest } from '../../docente/requests/insert-docente-request';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-adm-docentes-gestion',
  templateUrl: './adm-docentes-gestion.component.html',
  styleUrls: ['./adm-docentes-gestion.component.css']
})
export class AdmDocentesGestionComponent implements OnInit {

  addDocenteForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private toast : ToastrService,
              private adminService : AdminService) 
  {}

  ngOnInit() {

    this.addDocenteForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required,
                                  Validators.minLength(10),
                                  Validators.maxLength(85)]),
      username: new FormControl('', [Validators.required,
                                      Validators.pattern(/^[^\sñ]+$/),
                                      Validators.maxLength(15),
                                      Validators.minLength(5),
                                      Validators.pattern(/^[a-zA-Z0-9]+$/)
                                    ]),
    });
  }

  trySubmit()
  {
    if(this.addDocenteForm.invalid)
    {
      this.toast.error('Verifique la información','error');
      return;
    }
    try {
      //assign values
      let request = {} as InsertDocenteRequest;
      request.nombre = this.f.name.value;
      request.usuario = this.f.username.value;
      request.password = this.f.username.value;

      this.adminService.agregarDocente(request).subscribe({
        next: (result) => 
        {
          if(result.idUsuario>0)
            this.toast.success(result.mensaje,'');
          else
            this.toast.error(result.mensaje,'');
        },
        error: (error) => {
          this.toast.error('Ocurrio un error con el servidor','error');
        },
        complete: () => 
        {
          this.addDocenteForm.reset();
        }
    });
    } catch (error) {
      this.toast.error('Ocurrio un error con el servidor','error');
    }
  }

  
  get f() {
    return this.addDocenteForm.controls;
  }

}
